import React from "react";
import PubSub from "pubsub-js";
import { intFormat, formatCurrency } from "../../../../../../js/shared/utils";
import Slider from "../../../../../shared/Slider/Slider";

export const FidelityBonus = props => {
	return (
		<div className={props.className}>
			<form className="form-offer block-center simulator-miles--bonus-slider">
				<div className="row">
					<div className="col-xs-16 col-md-12">
						<p className="header-bonus">
							Cadastre cada 1.000 milhas por até {formatCurrency(props.bonusMaxPrice)}
						</p>
						<p className="subheader-bonus">
							Atenda os critérios abaixo para poder cadastrar suas milhas por um valor maior.
						</p>
					</div>
					<div className="col-xs-12 col-xs-offset-4 col-md-offset-0 col-md-4">
						<button
							className="btn btn-change-price"
							type="button"
							style={{ visibility: props.eligableColor == "green" ? "visible" : "hidden" }}
							data-action="simulator-miles-valid-bonus-scroll"
							onClick={() => {
								window.scrollTo({
									top:
										document
											.querySelector('[data-action="simulator-miles-price"]')
											.getBoundingClientRect().top +
										window.scrollY -
										95,
									behavior: "smooth"
								});
								if (props.focusInputPrice) {
									setTimeout(props.focusInputPrice, 500);
								}
							}}
						>
							Alterar o preço das milhas
						</button>
					</div>
				</div>
				<div className="simulador-smiles-dynamic-range d-flex">
					<Slider
						min={0}
						max={30000}
						rangeMin={props.startAverage}
						rangeMax={props.endAverage}
						step={500}
						defaultValue={props.bestAverage}
						onChange={props.changeAverageSlider}
						validRange={props.validRange}
						className="simulador-smiles-dynamic-range--slider--component"
						id="average_slider"
						name="average_slider"
						value={props.averageMiles}
					/>
				</div>

				<p className="bonus-information--message">
					<span>
						<i className={`icon-${props.eligableAverage == "green" ? "check" : "close"}`} />
						Arraste o ponteiro para que sua média de milhas por passageiro fique entre{" "}
						{intFormat(props.startAverage)} e {intFormat(props.endAverage)} milhas.
					</span>
				</p>

				<p className="bonus-information--message">
					<span>
						<i className={`icon-${props.eligableQuant == "green" ? "check" : "close"}`} />A
						quantidade de milhas da oferta deve ser entre {intFormat(props.minEligableQuant)} e{" "}
						{intFormat(props.maxEligableQuant)} milhas.
					</span>
				</p>
			</form>
		</div>
	);
};

export default FidelityBonus;
